import {Component, Input, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";

@Component({
  selector: 'app-pseudo-popup',
  templateUrl: './pseudo-popup.component.html',
  styleUrls: ['./pseudo-popup.component.scss'],
})
export class PseudoPopupComponent implements OnInit {
  @Input() title!: string;
  @Output() dismissed: Subject<void> = new Subject<void>();
  constructor() { }
  onClose_click() {
    this.dismissed.next();
  }
  ngOnInit() {}

}
